import { Component, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LoginFacade } from 'src/app/login/state/login.facade';

@Component({
  selector: 'internal-login',
  templateUrl: './internal-login.page.html',
  styleUrls: ['./internal-login.page.scss'],
})
export class InternalLoginPage {
  private readonly loginFacade = inject(LoginFacade);

  readonly identifierFormControl = new FormControl('');
  readonly passwordFormControl = new FormControl('');

  login() {
    if (this.identifierFormControl.value === '' && this.passwordFormControl.value === '') {
      return;
    }

    this.loginFacade.login({
      identifier: this.identifierFormControl.value,
      password: this.passwordFormControl.value,
    }).subscribe({
      next: () => {
        window.location.href = '/';
      }
    });
  }
}
